<template>
  <div class="room-info-content" :style="isMobile ? 'height:auto' : ''">
    <!-- 移动端：全新的高级选项卡设计 -->
    <div v-if="isMobile" class="mobile-room-tabs">
      <div class="tabs-scroll-container">
        <div 
          class="mobile-tab-item"
          :class="{ 'active': activeIndex === index }"
          v-for="(item, index) in roomInfo" 
          :key="item.orderItemCode"
          @click="roomTypeClick(index, item)"
        >
          <div class="tab-glow"></div>
          <div class="tab-img-wrapper">
            <div class="tab-img-border">
              <img :src="item.upImgUrl" alt="">
            </div>
          </div>
          <div class="tab-content">
            <span class="tab-name">{{ item.itemCname }}</span>
            <span class="tab-price" v-if="item.price">¥{{ item.price }}/晚</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 桌面端原来的按钮区域 -->
    <div v-else class="room-type-btns">
      <div class="btn-item" :class="{
        'btn-active': activeIndex === index,
        'btn-ready': activeIndex + 1 === index || index === 0 && activeIndex === roomInfo.length - 1,
        'btn-animate': isAnimate && !isMobile
      }" v-for="(item, index) in roomInfo" :key="item.orderItemCode" :style="{
        top: `${getBtnTop(index)}px`,
        left: '0',
        transition: isAnimate ? '.5s ease' : 'none'
      }" @click="roomTypeClick(index, item)">
        <div class="room-type">{{ item.itemCname }}</div>
        <div class="img">
          <img :src="item.upImgUrl" alt="" lazy>
        </div>
      </div>
    </div>

    <div class="info-container">
      <div class="info-item info-left">
        <p class="info-text">伍号酒店<span style="color: #012059;font-weight: bold;">{{ roomInfo[activeIndex]?.infoMessage
        }}</span>给你带来极致享受</p>
        <a href="/room" class="btn btn-primary">了解更多</a>
      </div>
      <div class="info-item info-right">
        <div class="img-item up-img" :class="{ 'img-active-right': showImg && !isMobile }">
          <img :src="upImgUrl" alt="" lazy>
        </div>
        <div class="img-item down-img" :class="{ 'img-active-left': showImg && !isMobile }">
          <img :src="downImgUrl" alt="" lazy>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetRoomPriceList } from "@/utils/roomRequest";
import { getTodayFormatted, getTomorrowDate } from "@/utils/date";
import roomImgs from "@/assets/json/roomImgs.json";


// 节流函数-解决scroll卡顿 最小改动
const throttle = (fn, delay = 200) => {
  let timer = null;
  return function (...args) {
    if (!timer) {
      timer = setTimeout(() => {
        fn.apply(this, args);
        timer = null;
      }, delay);
    }
  };
};

export default {
  data() {
    return {
      isScrolled: false,
      scrollThreshold: 420,
      activeIndex: 0,
      roomInfo: [],
      isAnimate: false,
      btnHeight: 100,
      btnWidth: 120,
      downImgUrl: '',
      upImgUrl: '',
      timer: '',
      showImg: true,
      showItem: false,
      isMobile: false,
      autoTimer: '',
      startAutoPlayer: '',
      roomImageSData: roomImgs.roomImageSData,
    };
  },
  mounted() {
    // 节流处理scroll-解决高频触发卡顿
    window.addEventListener("scroll", throttle(this.handleScroll.bind(this)));
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.getRoomPriceList();

  },
  beforeUnmount() {
    window.removeEventListener("scroll", throttle(this.handleScroll.bind(this)));
    window.removeEventListener("resize", this.handleResize);
    // 统一清除定时器-解决内存泄漏
    this.clearAllTimers();
  },
  methods: {
    // 统一清除定时器-最小改动
    clearAllTimers() {
      this.autoTimer && clearInterval(this.autoTimer);
      this.timer && clearTimeout(this.timer);
      this.startAutoPlayer && clearTimeout(this.startAutoPlayer);
      this.autoTimer = this.timer = this.startAutoPlayer = '';
    },
    handleResize() {
      const isMobileNow = window.innerWidth <= 768;
      this.isMobile = isMobileNow;
      if (isMobileNow) {
        this.clearAllTimers();
        this.isAnimate = false;
      } else {
        this.$nextTick(() => {
          this.isAnimate = true;
          if (!this.autoTimer && this.roomInfo.length > 0) {
            this.autoPlay();
          }
        });
      }
    },
    // 优化图片查找-用find替代forEach 减少计算
    imgUrl(roomType, idx) {
      const base = 'https://www.hqhotel5.com/img/hotelImgs/';
      const item = this.roomImageSData.find(i => i.name === roomType);
      return item ? `${base}${item.imgs[idx] || item.imgs[0]}` : base;
    },
    async getRoomPriceList() {
      try {
        const res = await GetRoomPriceList({
          BeginDate: getTodayFormatted(),
          EndDate: getTomorrowDate(),
          ProfileId: "",
          RoomQty: "1",
          OrderItemCode: "",
        });
        const data = res.data.roomTypePricesList?.rows?.row || [];
        this.roomInfo = data.map((item) => ({
          ...item,
          infoMessage: `${item.itemCname}`,
          upImgUrl: this.imgUrl(item.itemCname, 0),
          downImgUrl: this.imgUrl(item.itemCname, 1),
          price: item.price || Math.floor(Math.random() * 500 + 300), // 模拟价格，实际应从接口获取
        }));
        if (this.roomInfo.length > 0) {
          this.upImgUrl = this.roomInfo[0].upImgUrl;
          this.downImgUrl = this.roomInfo[0].downImgUrl;
          this.$nextTick(() => {
            this.isAnimate = !this.isMobile;
            !this.isMobile && this.autoPlay();
          });
        }
      } catch (error) {
        console.error("获取房型列表失败：", error);
      }
    },
    // 简化滚动逻辑-减少冗余判断
    handleScroll() {
      if (this.isMobile || this.isScrolled) return;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop >= this.scrollThreshold) {
        this.isScrolled = true;
        setTimeout(() => {
          this.showItem = true;
        }, 400);
      }
    },
    // 简化切换逻辑-减少DOM更新卡顿
    handleBtnClick(targetIndex, item) {
      if (targetIndex === this.activeIndex) return;
      this.clearAllTimers();
      this.showImg = false;
      this.activeIndex = targetIndex;
      this.timer = setTimeout(() => {
        this.upImgUrl = item.upImgUrl;
        this.downImgUrl = item.downImgUrl;
        this.showImg = true;
        !this.isMobile && (this.startAutoPlayer = setTimeout(() => this.autoPlay(), 8000));
      }, 300); // 缩短过渡-提升流畅
    },
    roomTypeClick(idx, item) {
      this.handleBtnClick(idx, item);
    },
    autoPlay() {
      if (this.isMobile || this.roomInfo.length === 0) return;
      this.autoTimer = setInterval(() => {
        const idx = this.activeIndex + 1 >= this.roomInfo.length ? 0 : this.activeIndex + 1;
        this.handleBtnClick(idx, this.roomInfo[idx]);
      }, 6000);
    },
    getBtnTop(index) {
      const { activeIndex, btnHeight, roomInfo } = this;
      if (index === activeIndex) return 0;
      return index > activeIndex ? (index - activeIndex) * btnHeight : (roomInfo.length - activeIndex + index) * btnHeight;
    },
    getBtnLeft(index) {
      const { activeIndex, btnWidth } = this;
      const centerPercent = 50;
      const percentPerBtn = (btnWidth + 10) / window.innerWidth * 100;
      const baseLeft = centerPercent - (btnWidth / 2);
      if (index === activeIndex) return baseLeft;
      return index > activeIndex ? baseLeft + (index - activeIndex) * percentPerBtn : baseLeft - (activeIndex - index) * percentPerBtn;
    }
  },
};
</script>

<style scoped lang="scss">
// 全局变量-统一酒店轻奢风配色
$primary: #012059;
$primary-light: rgba(1, 32, 89, 0.85);
$primary-hover: #02307a;
$white: #ffffff;
$gray-light: rgba(255, 255, 255, 0.95);
$shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
$shadow-hover: 0 6px 20px rgba(0, 0, 0, 0.12);
$radius-sm: 8px;
$radius-md: 16px;
$radius-lg: 50px;

.room-info-content {
  height: 90vh;
  width: 90vw;
  position: relative;
  margin: 0 auto;
  padding-top: 30px;
  overflow: hidden;
  transition: all 0.8s cubic-bezier(0.2, 0.8, 0.2, 1);
  display: flex;
  justify-content: end;

  // 优化显隐动画-用3d变换开启GPU加速 解决卡顿  
  .room-type-btns,
  .info-container {
    position: relative;
    width: 100%;
    height: 100%;
    transition: all 0.8s cubic-bezier(0.2, 0.8, 0.2, 1);
    will-change: opacity, transform;
    transform: translate3d(0, 20px, 0);
  }

  .room-type-btns {
    position: absolute;
    top: 30px;
    left: 0;

    .btn-item {
      position: absolute;
      left: 0;
      width: 8%;
      padding: 10px;
      display: flex;
      align-items: center;
      gap: 10px;
      cursor: pointer;
      border-radius: $radius-lg;
      will-change: top, left, width;
      text-align: center;
      background: linear-gradient(to right, $primary-light, $primary-light);
      color: $white;
      box-sizing: border-box;
      transform: translate3d(0, 0, 0);
      border: 2px solid transparent;

      .room-type {
        width: 0;
        overflow: hidden;
        transition: .5s ease;
        word-break: keep-all;
        font-weight: 600;
        font-size: 16px;
      }

      .img {
        width: 70px;
        height: 70px;
        border-radius: 50%;
        overflow: hidden;
        transition: .5s ease;
        border: 2px solid $white;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      &:hover {
        width: 15%;
        background: linear-gradient(to right, $primary-hover, $primary-hover);

        .img {
          transform: rotate(360deg);
        }

        .room-type {
          width: 50%;
          font-size: 18px;
        }
      }
    }

    .btn-ready {
      width: 15%;

      .img {
        transform: rotate(360deg);
      }

      .room-type {
        width: 50%;
        font-size: 18px;
      }
    }

    .btn-active {
      border-radius: $radius-lg 0 0 $radius-lg;
      pointer-events: none;
      background: linear-gradient(to right, $primary-light, transparent);
      width: 70%;
      border-color: rgba($white, 0.3);

      .img {
        transform: rotate(720deg);
        opacity: 0;
      }

      .room-type {
        width: 85%;
        font-size: 30px;
        text-align: center;
      }
    }
  }

  .info-container {
    width: 92%;
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 10px;
    padding: 0 20px;

    .info-item {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      padding: 20px;
    }

    .info-left {
      .info-text {
        font-size: 18px;
        line-height: 1.8;
        margin-bottom: 30px;
        color: #333;
        max-width: 80%;
        text-align: center;
        font-weight: 400;
      }

      .btn-primary {
        padding: 12px 36px;
        background: linear-gradient(135deg, $primary, $primary-hover);
        color: $white;
        border-radius: $radius-lg;
        text-decoration: none;
        border: none;
        transition: all 0.3s ease;
        font-size: 16px;
        font-weight: 500;
        box-shadow: $shadow;

        &:hover {
          background: linear-gradient(135deg, $primary-hover, $primary);
          transform: translateY(-2px);
          box-shadow: $shadow-hover;
        }
      }
    }

    .info-right {
      position: relative;
      padding: 0;

      .img-item {
        position: absolute;
        max-width: 400px;
        height: 70%;
        border-radius: $radius-md;
        overflow: hidden;
        transition: all 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
        border: 3px solid $white;
        box-shadow: $shadow;
        transform: translate3d(0, 0, 0);
        will-change: left, right, opacity;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .up-img {
        top: 0;
        opacity: 0;
        right: -100%;
      }

      .down-img {
        bottom: 50px;
        opacity: 0;
        left: -100%;
      }

      .img-active-right {
        right: 0;
        opacity: 1;
        box-shadow: $shadow-hover;
      }

      .img-active-left {
        left: -35%;
        opacity: 1;
        box-shadow: $shadow-hover;
      }
    }
  }
}

/* ========== 移动端高级UI设计 - 奢华酒店风格 ========== */
@media (max-width: 768px) {
  .room-info-content {
    height: auto;
    width: 100%;
    padding: 0;
    margin: 0;
    overflow: visible;
    background: linear-gradient(135deg, #f8f9fc 0%, #f0f2f6 100%);
    display: block;
  }

  // 高级选项卡容器
  .mobile-room-tabs {
    position: relative;
    padding: 20px 0 32px;
    background: transparent;
    overflow: hidden;
    
    // 渐变背景装饰
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 200px;
      background: linear-gradient(135deg, rgba(1, 32, 89, 0.03) 0%, rgba(1, 32, 89, 0) 100%);
      pointer-events: none;
    }
    
    .tabs-scroll-container {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      overflow-x: auto;
      overflow-y: hidden;
      gap: 16px;
      padding: 8px 20px 16px;
      scrollbar-width: thin;
      scrollbar-color: #012059 #e0e4e8;
      -webkit-overflow-scrolling: touch;
      
      &::-webkit-scrollbar {
        height: 3px;
      }
      
      &::-webkit-scrollbar-track {
        background: #e0e4e8;
        border-radius: 3px;
      }
      
      &::-webkit-scrollbar-thumb {
        background: #012059;
        border-radius: 3px;
      }
    }
    
    .mobile-tab-item {
      position: relative;
      flex-shrink: 0;
      width: 110px;
      padding: 12px 0 16px;
      background: rgba(255, 255, 255, 0.9);
      backdrop-filter: blur(10px);
      border-radius: 24px;
      transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
      cursor: pointer;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
      
      // 光晕效果
      .tab-glow {
        position: absolute;
        inset: 0;
        border-radius: 24px;
        background: radial-gradient(circle at 50% 0%, rgba(1, 32, 89, 0.1), transparent);
        opacity: 0;
        transition: opacity 0.3s ease;
        pointer-events: none;
      }
      
      // 图片容器
      .tab-img-wrapper {
        display: flex;
        justify-content: center;
        margin-bottom: 12px;
        
        .tab-img-border {
          width: 70px;
          height: 70px;
          border-radius: 50%;
          background: linear-gradient(135deg, #012059, #02307a);
          padding: 2px;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          
          img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
            object-fit: cover;
            background: #f0f2f6;
            transition: transform 0.3s ease;
          }
        }
      }
      
      // 文字内容区
      .tab-content {
        text-align: center;
        
        .tab-name {
          display: block;
          font-size: 14px;
          font-weight: 600;
          color: #2c3e50;
          margin-bottom: 4px;
          letter-spacing: 0.5px;
        }
        
        .tab-price {
          display: block;
          font-size: 11px;
          color: #012059;
          font-weight: 500;
          opacity: 0;
          transform: translateY(-4px);
          transition: all 0.3s ease;
        }
      }
      
      // 激活状态
      &.active {
        background: white;
        box-shadow: 0 12px 24px rgba(1, 32, 89, 0.12), 0 4px 8px rgba(0, 0, 0, 0.04);
        transform: translateY(-4px);
        
        .tab-glow {
          opacity: 1;
        }
        
        .tab-img-wrapper .tab-img-border {
          transform: scale(1.05);
          background: linear-gradient(135deg, #012059, #2c5f8a);
          box-shadow: 0 4px 12px rgba(1, 32, 89, 0.2);
          
          img {
            transform: scale(0.98);
          }
        }
        
        .tab-content {
          .tab-name {
            color: #012059;
            font-weight: 700;
          }
          
          .tab-price {
            opacity: 1;
            transform: translateY(0);
          }
        }
      }
      
      // 点击反馈
      &:active {
        transform: scale(0.96);
        transition-duration: 0.1s;
      }
    }
  }

  // 信息容器高级优化
  .info-container {
    display: flex !important;
    flex-direction: column !important;
    gap: 20px !important;
    width: 100% !important;
    padding: 0 16px 32px !important;
    margin: 0 !important;

    // 图片区域 - 画廊风格
    .info-right {
      order: 1;
      height: auto !important;
      display: flex !important;
      flex-direction: column !important;
      gap: 16px !important;
      padding: 0 !important;
      
      .img-item {
        position: relative !important;
        width: 100% !important;
        height: 220px !important;
        border-radius: 20px !important;
        opacity: 1 !important;
        left: auto !important;
        right: auto !important;
        top: auto !important;
        bottom: auto !important;
        overflow: hidden;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
        transition: transform 0.3s ease, box-shadow 0.3s ease;
        
        &:hover {
          transform: translateY(-4px);
          box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12);
        }
        
        &::after {
          content: '';
          position: absolute;
          inset: 0;
          background: linear-gradient(to top, rgba(0, 0, 0, 0.1), transparent);
          pointer-events: none;
        }
        
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.5s ease;
        }
        
        &:hover img {
          transform: scale(1.05);
        }
      }
    }

    // 文字区域 - 卡片高级质感
    .info-left {
      order: 2;
      padding: 28px 20px !important;
      background: rgba(255, 255, 255, 0.95);
      backdrop-filter: blur(10px);
      border-radius: 28px;
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04);
      border: 1px solid rgba(255, 255, 255, 0.8);
      
      .info-text {
        font-size: 15px !important;
        line-height: 1.7 !important;
        margin-bottom: 24px !important;
        color: #4a5568 !important;
        font-weight: 400;
        letter-spacing: 0.3px;
        
        span {
          display: inline-block;
          background: linear-gradient(135deg, rgba(1, 32, 89, 0.08), rgba(1, 32, 89, 0.04));
          padding: 2px 12px;
          border-radius: 20px;
          font-weight: 600;
          margin: 0 4px;
        }
      }
      
      .btn-primary {
        padding: 12px 32px !important;
        font-size: 14px !important;
        font-weight: 500;
        letter-spacing: 0.5px;
        background: linear-gradient(135deg, #012059, #02307a);
        border-radius: 40px;
        box-shadow: 0 4px 12px rgba(1, 32, 89, 0.2);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        
        &:active {
          transform: scale(0.96);
          box-shadow: 0 2px 6px rgba(1, 32, 89, 0.2);
        }
      }
    }
  }
  
  // 动画优化
  .mobile-tab-item {
    animation: fadeInUp 0.5s ease backwards;
    
    @for $i from 1 through 10 {
      &:nth-child(#{$i}) {
        animation-delay: #{$i * 0.05}s;
      }
    }
  }
  
  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
}

// 小屏幕优化
@media (max-width: 480px) {
  .mobile-room-tabs {
    padding: 16px 0 24px;
    
    .tabs-scroll-container {
      gap: 12px;
      padding: 8px 16px 12px;
    }
    
    .mobile-tab-item {
      width: 95px;
      padding: 10px 0 14px;
      
      .tab-img-wrapper .tab-img-border {
        width: 60px;
        height: 60px;
      }
      
      .tab-content .tab-name {
        font-size: 13px;
      }
    }
  }
  
  .info-container {
    .info-right .img-item {
      height: 180px !important;
    }
    
    .info-left {
      padding: 24px 16px !important;
      
      .info-text {
        font-size: 14px !important;
      }
    }
  }
}

// 大屏手机优化 (iPhone Plus/Pro Max)
@media (min-width: 768px) and (max-width: 896px) {
  .mobile-room-tabs .mobile-tab-item {
    width: 120px;
    
    .tab-img-wrapper .tab-img-border {
      width: 75px;
      height: 75px;
    }
  }
  
  .info-container .info-right .img-item {
    height: 250px !important;
  }
}
</style>